module.exports = __webpack_public_path__ + "img/bzlx.ce396115.png";